<template>
	<div class="head clearfix">
		<span>{{title}}国家基本公共卫生服务项目动态监测</span>
		<div class="header-right">
			<div class="dateBox">
				<span>{{ riqi }}</span>
				<span>{{ time }}</span>
				<span>{{ week }}</span>
			</div>
			<button class="logout-btn" @click="handleLogout">退出登录</button>
		</div>
	</div>
</template>

<script>
	export default {
		props:{
			title:{
				type:String,
				default:''
			}
		},
		data(){
			return{
				time:'',
				riqi:'',
				week:'',
				num:0
			}
		},
		created() {
			this.getTimeStr()
			setInterval(()=>{
				this.getTimeStr()
				const date=new Date()
				let hour=date.getHours()
				if(hour==7&&this.num>3600){
					this.$emit("refresh")
				}
				this.num++
			},1000)			
		},
		methods: {
			getTimeStr(){
				const date=new Date();
				const weeks=['星期日','星期一','星期二','星期三','星期四','星期五','星期六']
				date.getDay()
				this.time=`${date.getHours()}:${date.getMinutes().toString().padStart(2,'0')}`
				this.riqi=`${date.getFullYear()}年${(date.getMonth()+1).toString().padStart(2,'0')}月${date.getDate().toString().padStart(2,'0')}日`
				this.week=`${weeks[date.getDay()]}`
			},
			handleLogout(){
				// 清除localStorage中的token
				localStorage.removeItem('third-token');
				// 跳转到登录页面
				this.$router.replace('/');
			}
		}
	}
</script>

<style scoped lang="stylus">
	.head{
		width 100%
		height 76px
		background url(../assets/img/head.png) no-repeat center
		background-size auto 100%
		position relative
		text-align: center
			span{
				font-family: Source Han Sans CN
				font-weight: 800
				font-size: 32px
				color: #FFFFFF
				line-height: 76px
			}
	}
	.header-right{
		position absolute
		right 20px
		top 50%
		transform translateY(-50%)
		display flex
		align-items: center
		color: #fff
	}

	.dateBox{
		display flex
		align-items: center
		margin-right: 20px
			span{
				margin-left: 10px
				font-family: Source Han Sans CN;
				font-weight: 500;
				font-size: 21px;
				color: #01E5BE;
				line-height: 21px;
			}
	}

	.logout-btn{
		padding: 8px 16px
		background: rgba(255, 255, 255, 0.1)
		backdrop-filter: blur(10px)
		-webkit-backdrop-filter: blur(10px)
		border: 1px solid rgba(255, 255, 255, 0.2)
		border-radius: 5px
		color: #fff
		font-size: 14px
		cursor: pointer
		transition: all 0.3s ease
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2)

		&:hover{
			background: rgba(255, 255, 255, 0.2)
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3)
		}
	}
</style>
